import React from 'react';
import { useCompany } from '../../context/CompanyContext';
import DocumentModal from '../ProductDescription/DocumentModal';

/**
 * Unified DocumentModal Component
 * 
 * This component automatically fetches company knowledge base documents
 * and passes them to the existing DocumentModal, eliminating the need
 * to manually add useCompany hook to every page.
 * 
 * Usage:
 * <UnifiedDocumentModal
 *   show={showModal}
 *   onHide={() => setShowModal(false)}
 *   // ... all other DocumentModal props
 * />
 */
const UnifiedDocumentModal = (props) => {
  const { allDocuments, groupedDocuments } = useCompany();

  // Pass all props to DocumentModal, automatically including both flat and grouped documents
  return (
    <DocumentModal
      {...props}
      companyKnowledgeDocs={allDocuments}
      groupedDocuments={groupedDocuments}
    />
  );
};

export default UnifiedDocumentModal;
